import { render, staticRenderFns } from "./intelligentReservoir.vue?vue&type=template&id=b763fde0&scoped=true"
import script from "./intelligentReservoir.vue?vue&type=script&lang=js"
export * from "./intelligentReservoir.vue?vue&type=script&lang=js"
import style0 from "./intelligentReservoir.vue?vue&type=style&index=0&id=b763fde0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b763fde0",
  null
  
)

export default component.exports